module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_8019.9a8a9d08.png";